import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PageTitle() {
  const loc = useLocation();
  useEffect(() => {
    const p = loc.pathname;
    let title = "DataSprint";
    if (p.startsWith("/admin")) title = "DataSprint · Admin";
    else if (p === "/login") title = "Login · DataSprint";
    else if (p.startsWith("/dashboard")) title = "DataSprint";
    else if (p === "/about") title = "About · DataSprint";
    else if (p === "/faq") title = "FAQ · DataSprint";
    else if (p === "/contact") title = "Contact · DataSprint";
    document.title = title;
  }, [loc.pathname]);
  return null;
}
